import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbSalesRepDto} from "../model/QbSalesRepDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbSalesRepSelectController implements IComponentController {
    records: QbSalesRepDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbSalesRep(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.qbSalesRepSubscribeAndQuery().then(ret=>this.records=ret);
    };

    $onInit(): void {
    }
    $onDestroy?() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.qbSalesRepSelect', [])
    .component('qbSalesRepSelect', {
        template: require('./QbSalesRepSelect.html'),
        controller: QbSalesRepSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
